import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Container,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import AutoAwesomeMosaicOutlinedIcon from "@mui/icons-material/AutoAwesomeMosaicOutlined";
import ChecklistRtlOutlinedIcon from "@mui/icons-material/ChecklistRtlOutlined";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import DragIndicatorOutlinedIcon from "@mui/icons-material/DragIndicatorOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import FilterVintageOutlinedIcon from "@mui/icons-material/FilterVintageOutlined";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";
import SlideshowOutlinedIcon from "@mui/icons-material/SlideshowOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import Header from "../header_h/Header";
import Footer from "../footer/Footer";
import Module from "../modules/module/Module";
import hedgehogImage from "../../images/20260524_140351_6a05fda1.png";
import hedgehogImageAlt from "../../images/20260524_140216_655bab51.png";
import hedgehogImageThird from "../../images/20260524_140211_421618ab.png";
import filwordImage from "../../images/filword.png";
import "./AuthorTaskDemoPage.css";

const demoTasks = [
  {
    key: "text",
    label: "Текстовий блок",
    description: "Матеріал без перевірки відповіді",
    question: {
      id: "demo-text",
      type: "text",
      subtitle: "Приклад презентаційного блоку",
      text: `
        <p><strong>Текстовий блок</strong> використовується, коли потрібно дати учням матеріал без перевірки відповіді: правило, уривок, пояснення або покрокову інструкцію.</p>
        <p>Автор може додавати кілька абзаців, виділяти ключові поняття, вставляти приклади й готувати учня до наступного інтерактивного завдання.</p>
        <p>Наприклад: спочатку учень читає коротке пояснення, потім переходить до тесту, вправи з пропусками або завдання з перетягуванням.</p>
      `,
    },
  },
  {
    key: "presentation",
    label: "Презентація",
    description: "Вбудована презентація з OneDrive",
    presentationSrc: "https://1drv.ms/p/c/8b131763810f9c95/IQQVQzr1OZXRTrRwGTgjUydYAWgfNefhOsgcL8DeZ5ldZoI",
  },
  {
    key: "test",
    label: "Тестове завдання",
    description: "Тестові питання з переходом далі",
    questions: [
      {
        id: "demo-test-1",
        type: "test",
        question: "<p>Яке слово є іменником?</p>",
        options: [
          { id: "А", text: "читати" },
          { id: "Б", text: "книжка" },
          { id: "В", text: "швидко" },
          { id: "Г", text: "зелений" },
        ],
        correctAnswer: "Б",
      },
      {
        id: "demo-test-2",
        type: "test",
        question: "<p>Яке слово є дієсловом?</p>",
        options: [
          { id: "А", text: "урок" },
          { id: "Б", text: "синій" },
          { id: "В", text: "пише" },
          { id: "Г", text: "тихо" },
        ],
        correctAnswer: "В",
      },
    ],
  },
  {
    key: "dropdown2",
    label: "Випадаючий Список",
    description: "Кожен пропуск має власні варіанти",
    question: {
      id: "demo-dropdown2",
      type: "dropdown2",
      question: "Заповніть речення:\n1) Столиця України - [drop].\n2) День має [drop] години.\n3) Автор тексту добирає [drop].\n4) Учень читає завдання [drop].",
      dropdowns: [
        { options: ["Київ", "Львів", "Одеса", "Харків", "Чернігів"], correctAnswer: "Київ" },
        { options: ["12", "24", "30", "60", "100"], correctAnswer: "24" },
        { options: ["заголовок", "слова", "погоду", "фарби", "квитки"], correctAnswer: "слова" },
        { options: ["уважно", "навмання", "пошепки", "вчора", "кругло"], correctAnswer: "уважно" },
      ],
    },
  },
  {
    key: "input",
    label: "Заповення пропусків",
    description: "Учень друкує відповіді у пропусках",
    question: {
      id: "demo-input",
      type: "input",
      question: "Вставте пропущені слова:\n1) Тарас [12]\n2) Леся [12]\n3) Автор створює [14]\n4) Учень виконує [16]",
      correctAnswers: ["Шевченко", "Українка", "оповідання", "інтерактив"],
    },
  },
  {
    key: "imageQuiz",
    label: "Фото Вікторина",
    description: "Вибір правильної картинки",
    question: {
      id: "demo-image-quiz",
      type: "imageQuiz",
      question: "Оберіть зображення де присутні 2 їжачки",
      options: [
        { id: "А", text: "Варіант 1", imgPath: hedgehogImage },
        { id: "Б", text: "Варіант 2", imgPath: hedgehogImageAlt },
        { id: "В", text: "Варіант 3", imgPath: hedgehogImageThird },
      ],
      correctAnswer: "Б",
      isTest: true,
    },
  },
  {
    key: "matchingPairs",
    label: "Скласти пари",
    description: "Поєднання карток",
    question: {
      id: "demo-matching",
      type: "matchingPairs",
      question: "Поєднайте термін із поясненням.",
      leftTitle: "Термін",
      rightTitle: "Пояснення",
      pairs: [
        {
          id: "pair1",
          left: { text: "Автор", imgPath: "" },
          right: { text: "Створює текст", imgPath: "" },
        },
        {
          id: "pair2",
          left: { text: "Читач", imgPath: "" },
          right: { text: "Сприймає текст", imgPath: "" },
        },
      ],
    },
  },
  {
    key: "dnd",
    label: "Перетягування у кошики (застаріле)",
    description: "Учень перетягує слова в потрібні групи",
    question: {
      id: "demo-dnd",
      type: "dnd",
      question: "<p>Розподіліть слова за частинами мови.</p>",
      initialWords: [
        { id: 1, text: "школа", type: "leftBucket" },
        { id: 2, text: "пише", type: "rightBucket" },
        { id: 3, text: "учень", type: "leftBucket" },
        { id: 4, text: "читає", type: "rightBucket" },
      ],
      leftBucketTitle: "Іменники",
      rightBucketTitle: "Дієслова",
      bucketsAmount: 2,
    },
  },
  {
    key: "dnd2",
    label: "Перетягування у кошики",
    description: "Гнучка вправа з кількома зонами для перетягування",
    question: {
      id: "demo-dnd2",
      type: "dnd2",
      question: "<p>Розкладіть приклади за групами.</p>",
      bucketCount: 3,
      bucketSize: 2,
      buckets: [
        { id: "noun", title: "Іменник", backgroundImage: "" },
        { id: "verb", title: "Дієслово", backgroundImage: "" },
        { id: "adjective", title: "Прикметник", backgroundImage: "" },
      ],
      initialWords: [
        { id: 1, text: "сонце", type: "noun" },
        { id: 2, text: "малює", type: "verb" },
        { id: 3, text: "яскравий", type: "adjective" },
      ],
    },
  },
  {
    key: "fillword",
    label: "Філворд",
    description: "Пошук слів у сітці",
    question: {
      id: "demo-fillword",
      type: "fillword",
      question: "Знайдіть слова у філворді.",
      imgPath: filwordImage,
      correctWords: ["сонце", "ліс", "квітка"],
    },
  },
  {
    key: "puzzle",
    label: "Пазл (п'ятнашки)",
    description: "Плитки міняються місцями",
    question: {
      id: "demo-puzzle",
      type: "puzzle",
      question: "Складіть зображення, міняючи плитки місцями.",
      imgPath: hedgehogImage,
      rows: 3,
      columns: 3,
      showPreview: true,
    },
  },
  {
    key: "jigsaw",
    label: "Класичний пазл",
    description: "Деталі складаються в цілісне зображення",
    question: {
      id: "demo-jigsaw",
      type: "jigsaw",
      question: "З'єднайте деталі пазла.",
      imgPath: hedgehogImage,
      rows: 2,
      columns: 2,
      showPreview: true,
    },
  },
  {
    key: "wordGrid",
    label: "Сітка слів",
    description: "Вписування слів за підказками",
    question: {
      id: "demo-word-grid",
      type: "wordGrid",
      question: "Розгадайте слова за підказками.",
      instruction: "Заповніть клітинки. Виділені літери по вертикалі утворюють слово КНИГА.",
      wordRows: [
        { id: "row-1", clue: "Місце, де навчаються", answer: "ш[к]ола", offset: 2 },
        { id: "row-2", clue: "Світить удень", answer: "со[н]це", offset: 1 },
        { id: "row-3", clue: "Друкований навчальний матеріал", answer: "кн[и]га", offset: 1 },
        { id: "row-4", clue: "Домовленість або згода", answer: "у[г]ода", offset: 2 },
        { id: "row-5", clue: "Письмове завдання", answer: "впр[а]ва", offset: 0 },
      ],
      revealedLetterColor: "#c62828",
    },
  },
  {
    key: "logicalSequence",
    label: "Логічна послідовність",
    description: "Перетягування пунктів у правильному порядку",
    question: {
      id: "demo-logical-sequence",
      type: "logicalSequence",
      question: "<p>Розташуйте етапи роботи з текстом у правильній послідовності.</p>",
      items: [
        { id: "А", text: "Написати чернетку" },
        { id: "Б", text: "Перевірити помилки" },
        { id: "В", text: "Обрати тему" },
        { id: "Г", text: "Опублікувати фінальний текст" },
      ],
      correctOrder: ["В", "А", "Б", "Г"],
    },
  },
  {
    key: "video",
    label: "Відеозавдання",
    description: "Відео з питанням або самостійною роботою",
    question: {
      id: "demo-video",
      type: "video",
      question: "<p>Перегляньте відео й оберіть правильну відповідь.</p>",
      videoPath: "https://www.youtube.com/embed/fNMjNLm83-w",
      options: [
        { id: "А", text: "Відео можна поєднати з тестом" },
        { id: "Б", text: "Відео не підтримується" },
      ],
      correctAnswer: "А",
      isTest: true,
      shouldGoNext: true,
    },
  },
  {
    key: "pdf",
    label: "PDF",
    description: "Перегляд, пошук, масштабування і завантаження",
    question: {
      id: "demo-pdf",
      type: "pdf",
      question: "<p>PDF-блок показує документ прямо в завданні.</p>",
      pdfPath: "/pdf/ukr_avr_8/module01.pdf",
      pdfFileName: "demo.pdf",
    },
  },
];

const getTaskIcon = (key) => {
  if (key === "text") return <ArticleOutlinedIcon />;
  if (key === "test") return <QuizOutlinedIcon />;
  if (key === "dropdown2") return <ArrowDropDownCircleOutlinedIcon />;
  if (key === "input") return <EditNoteOutlinedIcon />;
  if (key === "imageQuiz") return <PhotoLibraryOutlinedIcon />;
  if (key === "matchingPairs") return <LinkOutlinedIcon />;
  if (key === "dnd") return <DragIndicatorOutlinedIcon />;
  if (key === "dnd2") return <DashboardCustomizeOutlinedIcon />;
  if (key === "fillword") return <FilterVintageOutlinedIcon />;
  if (key === "puzzle") return <AutoAwesomeMosaicOutlinedIcon />;
  if (key === "jigsaw") return <ExtensionOutlinedIcon />;
  if (key === "wordGrid") return <GridOnOutlinedIcon />;
  if (key === "logicalSequence") return <ChecklistRtlOutlinedIcon />;
  if (key === "video") return <VideoLibraryOutlinedIcon />;
  if (key === "pdf") return <InsertDriveFileOutlinedIcon />;
  if (key === "presentation") return <SlideshowOutlinedIcon />;
  return <ArticleOutlinedIcon />;
};

function AuthorTaskDemoPage({ userName, userRoles }) {
  const [selectedKey, setSelectedKey] = useState(demoTasks[0].key);
  const [resetNonce, setResetNonce] = useState(0);
  const selectedTask = useMemo(
    () => demoTasks.find((task) => task.key === selectedKey) || demoTasks[0],
    [selectedKey]
  );
  const demoModule = useMemo(
    () => ({
      title: selectedTask.label,
      questions: selectedTask.questions || (selectedTask.question ? [selectedTask.question] : []),
    }),
    [selectedTask]
  );

  return (
    <>
      <Header userName={userName} userRoles={userRoles} />
      <Container maxWidth="xl" className="author-demo-page">
        <Stack className="author-demo-layout" direction={{ xs: "column", md: "row" }} spacing={2}>
          <Paper className="author-demo-sidebar" variant="outlined">
            <Box className="author-demo-heading">
              <span className="author-demo-heading-icon">
                <SlideshowOutlinedIcon fontSize="small" />
              </span>
              <Box>
                <Typography variant="h5" component="h1">
                  Для авторів
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Інтерактивні приклади завдань
                </Typography>
              </Box>
            </Box>

            <List disablePadding>
              {demoTasks.map((task) => (
                <ListItemButton
                  key={task.key}
                  selected={task.key === selectedKey}
                  onClick={() => {
                    setSelectedKey(task.key);
                    setResetNonce((value) => value + 1);
                  }}
                  className="author-demo-type"
                >
                  <ListItemIcon className="author-demo-type-icon">
                    {getTaskIcon(task.key)}
                  </ListItemIcon>
                  <ListItemText primary={task.label} secondary={task.description} />
                </ListItemButton>
              ))}
            </List>
          </Paper>

          <Box className="author-demo-preview">
            <Paper className="author-demo-preview-toolbar" variant="outlined">
              <Box>
                <Typography variant="h6" component="h2">
                  {selectedTask.label}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {selectedTask.description}
                </Typography>
              </Box>
              <Button
                variant="outlined"
                startIcon={<RestartAltOutlinedIcon />}
                onClick={() => setResetNonce((value) => value + 1)}
              >
                Почати приклад заново
              </Button>
            </Paper>

            <Box className="author-demo-runtime" key={`${selectedTask.key}-${resetNonce}`}>
              {selectedTask.presentationSrc ? (
                <Paper className="author-demo-presentation" variant="outlined">
                  <iframe
                    src={selectedTask.presentationSrc}
                    title="Демо презентації"
                    frameBorder="0"
                    scrolling="no"
                    allowFullScreen
                  />
                </Paper>
              ) : (
                <Module module={demoModule} />
              )}
            </Box>
          </Box>
        </Stack>
      </Container>
      <Footer />
    </>
  );
}

export default AuthorTaskDemoPage;
